import { types } from 'mobx-state-tree'

const AppStore = types
  .model('AppStore', {
    isOpenSnackbar: false,
    snackbarType: 'success',
    snackbarMessage: '',
    isOpenNotification: false,
    notiMessage: types.frozen(),
    notiColor: ''
  })
  .actions(self => ({
    setIsOpenSnackbar(isOpenSnackbar) {
      self.isOpenSnackbar = isOpenSnackbar
    },
    setSnackbarType(snackbarType) {
      self.snackbarType = snackbarType
    },
    setSnackbarMessage(snackbarMessage) {
      self.snackbarMessage = snackbarMessage
    },
    setSnackbar(isOpenSnackbar, snackbarType, snackbarMessage) {
      self.isOpenSnackbar = isOpenSnackbar
      self.snackbarType = snackbarType
      self.snackbarMessage = snackbarMessage
    },
    setNotification(isOpenNotification, notiMessage, color) {
      self.isOpenNotification = isOpenNotification
      self.notiMessage = notiMessage
      self.notiColor = color
    },
    setIsOpenNotification(isOpenNotification) {
      self.isOpenNotification = isOpenNotification
    }
  }))

export default AppStore.create()
